module.exports = __webpack_public_path__ + "img/08_Bauwerktrennerin_2022_Foto.84bcfd04.jpg";